











































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

@Component
export default class DataTable extends Vue {
    // 属性
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop({ default: 10 })
    private itemsPerPage: number;

    @Prop({ default: () => [] })
    private dataSet: any[];

    @Prop({ default: true })
    private showIndex: boolean;

    @Prop({ default: () => ({}) })
    private defaultSortBy: { [key: string]: boolean };

    @Prop({ default: undefined })
    private caption: string | undefined;

    @Prop({ default: false })
    private highlightsLabel: boolean;

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private chunkItems: any[] = [];
    private headers: any[] = [];
    private index_header_name: string = '';
    private label_header_name: string = '';
    private sortBy: string[] = [];
    private sortDesc: boolean[] = [];
    private footerProps: { [key: string]: any } = {
        'show-first-last-page': true,
        'items-per-page-options': [5, 10, 20, 30, 50, -1],
    };

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    private get full_index_item_name() {
        return 'item.' + this.index_header_name;
    }

    private get full_label_item_name() {
        return 'item.' + this.label_header_name;
    }

    private get full_label_header_name() {
        return 'header.' + this.label_header_name;
    }

    /*----------------------------------*
     * Watch
     *-----------------------------------*/
    @Watch('dataSet')
    private changeDataSet() {
        this.makeDataSet();
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // データセット作成
        this.makeDataSet();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    // データセット作成
    private makeDataSet() {
        this.chunkItems.length = 0;
        this.headers.length = 0;
        for (let i in this.dataSet) {
            if (+i) {
                // items編集
                let tmp_item: any = {};
                if (this.showIndex) {
                    tmp_item['index'] = +i;
                }
                for (let j in this.dataSet[i]) {
                    tmp_item['item_' + j] = this.dataSet[i][j];
                }
                this.chunkItems.push(Object.assign({}, tmp_item));
            } else {
                // header編集
                if (this.showIndex) {
                    this.headers.push({
                        text: 'No.',
                        value: 'index',
                        align: 'left',
                    });
                }
                for (let j in this.dataSet[i]) {
                    const header = this.dataSet[i][j];
                    const value = 'item_' + j;
                    this.headers.push({ text: header, value: value });

                    // 初期ソートの設定があれば、Datatable用に変換して設定
                    if (Object.keys(this.defaultSortBy).includes(header)) {
                        this.sortBy.push(value);
                        this.sortDesc.push(this.defaultSortBy[header]);
                    }
                }
            }
        }

        // ラベル強調設定があれば、No列とラベル列の名前を設定
        if (this.highlightsLabel) {
            if (this.showIndex) {
                this.index_header_name = this.headers[0].value;
            }
            this.label_header_name = this.headers[this.headers.length - 1].value;
        }
    }
}
